import { setSubroute } from 'store/navbar'
import { injectReducers } from 'store/reducers'
import { setPageTitle } from 'utils/misc'
import {
  UserIsAuthenticated,
  UserHasValidPassword,
  UserDoesNotHaveRole,
  UserHasFeatures,
} from 'containers/authContainers'
import { STUDY_CONFIG_MAP, USER_ROLES_WITH_BLOCKED_VIRTUAL_VISIT_ACCESS } from 'utils/constants'
import CreateVisitsRoute from './routes/CreateVisits'
import visitsReducer from './routes/VisitsPage/modules/Visits'
import { actions } from './routes/VisitsPage/modules/Visits'

export default store => {
  return {
    path: 'virtualvisits',
    exact: true,
    getIndexRoute(location, cb) {
      store.dispatch(setSubroute('virtualvisits'))
      const { currentStudy } = store.getState().study
      setPageTitle(`Virtual Visit | Study ${currentStudy?.id ?? ''} | ${currentStudy?.platform_name ?? ''}`)
      injectReducers(store, { visits: visitsReducer })
      // React Router v3 getIndexRoute expects a route object with getComponent so the router resolves the component
      cb(null, {
        getComponent(nextState, cb2) {
          const { params } = nextState || {}
          const { studyID } = params || {}
          const { study } = store.getState()
          const { base_site_ids: baseSitesArr } = study?.currentStudy || {}
          const siteID = baseSitesArr?.[0]
          require.ensure(
            [],
            () => {
              const VisitsPageContainer = require('./routes/VisitsPage/containers/VisitsPageContainer').default
              store.dispatch(actions.fetchVisits(studyID, siteID))
              const IndexComponent = UserIsAuthenticated(
                UserHasValidPassword(
                  UserDoesNotHaveRole(
                    USER_ROLES_WITH_BLOCKED_VIRTUAL_VISIT_ACCESS,
                    UserHasFeatures(
                      VisitsPageContainer,
                      [STUDY_CONFIG_MAP.virtualVisits],
                      'compliance',
                      false,
                      false,
                    ),
                  ),
                ),
              )
              cb2(null, IndexComponent)
            },
            'virtualvisits',
          )
        },
      })
    },
    getChildRoutes(location, cb) {
      cb(null, [CreateVisitsRoute(store)])
    },
  }
}
